module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Navigation/Minus-c1f746427428999f6a5b3ee3f83986ee.svg";